import * as types from "../actions/ActionTypes";
import * as Constants from "../utilities/Constants";
import ErrorCodeHelper from "../utilities/ErrorCodeHelper";
import { getErrorMessage } from "../utilities/ErrorMessageHelper";
import UrlHelper from "../utilities/UrlHelper";

export const getInitialState = () => (
    {
        step: Constants.linkEmailSteps.first,
        email: "",
        redirectLocation: undefined,
        error: "",
        isResetEmailSending: false,
        isResetEmailSent: false,
    });

const emailLoginReducer = (state = getInitialState(), action) => {
    switch (action.type) {
    case types.SEND_VERIFY_EMAIL_FAILED: {
        return Object.assign({}, state, { step: action.currentStep });
    }
    case types.SEND_VERIFY_EMAIL_SUCCEEDED: {
        return Object.assign({}, state, { step: action.currentStep, email: action.email });
    }
    case types.VERIFY_EMAIL_GO_TO_FIRST_STEP: {
        return Object.assign({}, state, { step: Constants.linkEmailSteps.first });
    }
    case types.GO_TO_LINK_USER_TO_VIRTUAL_USER: {
        return Object.assign({}, state, { step: Constants.linkEmailSteps.enterPassword });
    }
    case types.VALIDATE_TICKET_SUCCEEDED: {
        return Object.assign({}, state, { email: action.response.Email });
    }
    case types.SET_EMAIL_SUCCEEDED:
    case types.LINK_TO_VIRTUAL_USER_SUCCEEDED: {
        return Object.assign({}, state, { redirectLocation: action.redirectLocation });
    }
    case types.SET_EMAIL_FAILED: {
        return ErrorCodeHelper.isTicketExpiredError(action.error)
            ? Object.assign({}, state, { redirectLocation: UrlHelper.getSetEmailTicketExpiredUrl() })
            : state; // toaster in OperationReducer
    }
    case types.RESEND_START_RESET_PASSWORD: {
        return { ...state, isResetEmailSending: true };
    }
    case types.RESEND_START_RESET_PASSWORD_DEBOUNCE_FINISHED: {
        return { ...state, isResetEmailSending: false, isResetEmailSent: true };
    }
    case types.BACK_TO_PASSWORD_FORM: {
        return { ...state, isResetEmailSent: false }; }
    case types.LINK_TO_VIRTUAL_USER_FAILED: {
        return Object.assign({}, state, { error: getErrorMessage(action.error) });
    }
    default:
        return state;
    }
};

export default emailLoginReducer;
